module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cloudAccountDialog.cloudAccountNotFound":"We could not find reference to this cloud connection within this tenant."}}')
  delete Component.options._Ctor
}
